export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/suv.dfda0e8c.svg","height":32,"width":88,"blurWidth":0,"blurHeight":0};